import { DefaultState, Filters } from 'store/types';

export const SET_OCCUPANCY_RATE_TABLE_FILTERS = "SET_OCCUPANCY_RATE_TABLE_FILTERS";

export type OccupancyRateTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetOccupancyRateTableFilters {
  type: typeof SET_OCCUPANCY_RATE_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type OccupancyRateTableFiltersActionTypes = SetOccupancyRateTableFilters;
